module.exports = __webpack_public_path__ + "img/pet-list.9f6c7059.jpg";